import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaTrash, FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Importing the down and up arrow icons
import { ToastContainer, toast } from 'react-toastify';

const ServicesFeesApplying = () => {
  const [data, setData] = useState([]);
  const [expanded, setExpanded] = useState(null); // State to track which list is expanded

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const token = localStorage.getItem('accessTokenAdmin');
      const apiUrl = 'https://production.washta.com/api/admin/serviceFee';

      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data.data);
        console.log('response.data.data.', response.data.data);
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('accessTokenAdmin');
    const apiUrl = `https://production.washta.com/api/admin/serviceFee/${id}`;

    try {
      await axios.delete(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Remove the deleted promo code from the state
      setData((prevData) => prevData.filter((promo) => promo._id !== id));
    } catch (err) {
      console.log('Error deleting promo code:', err.message);
    }
  };
  const handleDeleteParticular = async (shopId, promoId) => {
    const payload = {
        isAmountTaxable: promoId.isAmountTaxable,
        feeType: promoId.feeType, // fixed
        WashtaFees: promoId.WashtaFees,
        applyAs: promoId.applyAs, // perInvoice
        applyAt: [shopId],
        isDefault: !promoId.isDefault
    
    };
    const token = localStorage.getItem('accessTokenAdmin');
  try {
    const response = await axios.post('https://production.washta.com/api/admin/serviceFee', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
       setData((prevData) =>
        prevData.map((promo) => {
          if (promo._id === promoId) {
            return {
              ...promo,
              applyAt: promo.applyAt.filter((shop) => shop._id !== shopId),
            };
          }
          return promo;
        })
      );
      if (promoId.isDefault) {
        toast.success('Delete Commission All Shop & Added Commission Special Shop');
      } else {
        toast.success('Delete Commission Special Shop & Added Commission All Shop');
      }
      window.location.reload()
      
  } catch (error) {
    console.error('API Error:', error.response ? error.response.data : error.message);
  }
  };
  
  const toggleExpand = (id) => {
    setExpanded((prevExpanded) => (prevExpanded === id ? null : id)); // Toggle expand for the clicked item
  };

  return (
    <div>
      {data?.map((promo) => (
        <div key={promo._id}>
          {/* Render service fee details */}
          <div
            className="tope-customer-com-main"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px',
            }}
          >
            <div className="second-row-customer" style={{ cursor: 'pointer', width: '20%' }}>
              <div className="top-custorm-width">
                <h5 className="paragph-heading">Washta Fees</h5>
                <p className="h5-class-top-class">
                  {promo?.feeType === 'percentage' ? `${promo?.WashtaFees}%` : `${promo?.WashtaFees} AED`}
                </p>
              </div>
            </div>

            <div className="div-colm-order" style={{ width: '20%' }}>
              <p className="paragph-heading" style={{ fontSize: 11 }}>Fee Type</p>
              <p className="h5-class-top-class" style={{ fontWeight: 400 }}>{promo?.feeType}</p>
            </div>
            <div className="div-colm-order" style={{ width: '20%' }}>
              <p className="paragph-heading" style={{ fontSize: 11 }}>Commission</p>
              <p className="h5-class-top-class" style={{ fontWeight: 400 }}>{promo?.isDefault ?  "All Shop" : "Special Shop"}</p>
            </div>

            <div className="div-colm-order" style={{ width: '20%' }}>
              <p className="paragph-heading" style={{ fontSize: 11 }}>Number Of Shops</p>
              <p className="h5-class-top-class" style={{ fontWeight: 400 }}>{promo?.applyAt.length}</p>
            </div>

            <div className="div-colm-order" style={{ width: '20%' }}>
              <p className="paragph-heading" style={{ fontSize: 11 }}>Apply As</p>
              <p className="h5-class-top-class" style={{ fontWeight: 400 }}>{promo?.applyAs}</p>
            </div>

            {/* <div className="div-colm-order" style={{ width: '20%' }}>
              <p className="paragph-heading" style={{ fontSize: 11 }}>Is Amount Taxable</p>
              <p className="h5-class-top-class" style={{ fontWeight: 400 }}>
                {promo?.isAmountTaxable ? 'Yes' : 'No'}
              </p>
            </div> */}

            <div className="div-colm-order" style={{ width: '20%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
           <div className='flex'>
            <p className="paragph-heading" style={{ fontSize: 11 }}>Remove All Shop Fee</p>
              <FaTrash
                onClick={() => handleDelete(promo._id)}
                style={{ cursor: 'pointer', color: '#6b5fe4', marginLeft: '10px' }}
              />
              </div>
              {/* Render Arrow Icon */}
              {expanded === promo._id ? (
                <FaChevronUp
                  onClick={() => toggleExpand(promo._id)}
                  style={{ cursor: 'pointer', color: '#6b5fe4', marginLeft: '10px' }}
                />
              ) : (
                <FaChevronDown
                  onClick={() => toggleExpand(promo._id)}
                  style={{ cursor: 'pointer', color: '#6b5fe4', marginLeft: '10px' }}
                />
              )}
            </div>
          </div>

          {/* Render Shops List Below the Row (Only if expanded) */}
          {expanded === promo._id && (
            <div style={{ marginTop: '10px', paddingLeft: '20px' }}>
              {promo?.applyAt.map((shop) => (
                
                <div
                className="tope-customer-com-main"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}
              >
                <div className="second-row-customer" style={{ cursor: 'pointer', width: '20%',justifyContent:'flex-start' }}>
                  <img src={shop.coverImage} alt={shop.shopName} style={{  width: '50px', height: '50px', borderRadius: '5px',border:'0.5px solid #6b5fe4',objectFit:'cover'}} />
<div className='div-colm-order' style={{overflow:'hidden'}}>
<h5 className="paragph-heading">{shop?.shopName}</h5>
                    <p className="h5-class-top-class">
                   { shop?.shopDetails}
                    </p>
</div>
                </div>
    
                <div className="div-colm-order" style={{ width: '20%' }}>
                  <p className="paragph-heading" style={{ fontSize: 11 }}>Fee Type</p>
                  <p className="h5-class-top-class" style={{ fontWeight: 400 }}>{promo?.feeType}</p>
                </div>
                <div className="div-colm-order" style={{ width: '30%' }}>
                  <p className="paragph-heading" style={{ fontSize: 11 }}>Location</p>
                  <p className="h5-class-top-class" style={{ fontWeight: 400 }}>
                    {shop?.location?.text}
                  </p>
                </div>
                <div className="div-colm-order" style={{ width: '25%',paddingLeft:20 }}>
                  <p className="paragph-heading" style={{ fontSize: 11 }}>Apply As</p>
                  <p className="h5-class-top-class" style={{ fontWeight: 400 }}>{promo?.applyAs}</p>
                </div>
                <div className="div-colm-order" style={{ width: '15%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                <div className='flex'>
            <p className="paragph-heading" style={{ fontSize: 11 }}>Remove Shop Fee</p>
              <FaTrash
                onClick={() => handleDeleteParticular(shop._id,promo)}
                style={{ cursor: 'pointer', color: '#6b5fe4', marginLeft: '10px' }}
              />
              </div>
              </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      <ToastContainer/>
    </div>
  );
};

export default ServicesFeesApplying;
